module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "namespaces-index-page"
  }, [_c('namespaces-panel', {
    attrs: {
      "namespaces": _vm.specialNamespaces,
      "namespaces-path": _vm.namespacesPath,
      "webhooks-path": _vm.webhooksPath,
      "prefix": "sns_"
    }
  }, [_c('h5', {
    slot: "name"
  }, [_c('a', {
    attrs: {
      "data-placement": "right",
      "data-toggle": "popover",
      "data-container": ".panel-heading",
      "data-content": "<p>A namespace groups a series of repositories.</p>",
      "data-original-title": "What's this?",
      "tabindex": "0",
      "data-html": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  })]), _vm._v("\n      Special namespaces\n    ")])]), _vm._v(" "), _c('new-namespace-form', {
    attrs: {
      "state": _vm.state,
      "form-state": "newFormVisible"
    }
  }), _vm._v(" "), _c('namespaces-panel', {
    attrs: {
      "namespaces": _vm.normalNamespaces,
      "namespaces-path": _vm.namespacesPath,
      "webhooks-path": _vm.webhooksPath,
      "table-sortable": true
    }
  }, [_c('h5', {
    slot: "name"
  }, [_vm._v("Namespaces you have access to")]), _vm._v(" "), (_vm.canCreateNamespace) ? _c('div', {
    slot: "actions"
  }, [_c('toggle-link', {
    staticClass: "toggle-link-new-namespace",
    attrs: {
      "text": "Create new namespace",
      "state": _vm.state,
      "state-key": "newFormVisible"
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/abuild/rpmbuild/BUILD/Portus-v2.3/~/vue-loader/lib/template-compiler?{"id":"data-v-180f7f4f"}!/home/abuild/rpmbuild/BUILD/Portus-v2.3/~/vue-loader/lib/selector.js?type=template&index=0!./modules/namespaces/pages/index.vue
// module id = 358
// module chunks = 0